// ==========================
// Super Admin Permissions
// ==========================

// Dashboard Module 
export const DASHBOARD_ACCESS = 'dashboard_access';
export const DASHBOARD_BDT = 'dashboard_bdt';
export const DASHBOARD_USD = 'dashboard_usd';
export const DASHBOARD_DEMO = 'dashboard_demo';
// Coupon Module
export const COUPON_ACCESS       = "coupon_access";
export const COUPON_CREATE       = "coupon_create";
export const COUPON_EDIT         = "coupon_edit";
export const COUPON_DELETE       = "coupon_delete";

// Roles Module
export const ROLES_ACCESS       = "roles_access";
export const ROLES_CREATE       = "roles_create";
export const ROLES_SHOW         = "roles_show";
export const ROLES_EDIT         = "roles_edit";
export const ROLES_DELETE       = "roles_delete";

// Company Module
export const COMPANY_ACCESS = 'company_access';
export const COMPANY_CREATE = 'company_create';
export const COMPANY_EDIT = 'company_edit';
export const COMPANY_DELETE = 'company_delete';
export const COMPANY_PAUSE = 'company_pause';
export const COMPANY_RESUME = 'company_resume';
export const COMPANY_CANCEL = 'company_cancel';
export const COMPANY_RECURRING = 'company_recurring';
export const COMPANY_SIGN_IN_AS_USER = 'company_sign_in_as_user';

// Mail Template Module
export const MAIL_TEMPLATE_ACCESS = 'mail_template_access';
export const MAIL_TEMPLATE_CREATE = 'mail_template_create';
export const MAIL_TEMPLATE_EDIT   = 'mail_template_edit';
export const MAIL_TEMPLATE_DELETE = 'mail_template_delete';
export const MAIL_SEND = 'mail_send';

// Company Request Module
export const COMPANY_REQUEST_ACCESS        = 'company_request_access';
export const COMPANY_REQUEST_APPROVE       = 'company_request_approve';
export const COMPANY_ASSIGN_PACKAGE        = 'company_assign_package';

export const USER_ACCESS        = 'user_access';
export const USER_CREATE        = 'user_create';
export const USER_EDIT          = 'user_edit';
export const USER_DELETE        = 'user_delete';